import {
    GetList,
    PostClient,
    GetClient,
    PutClient,
    DeleteClient,
    GetListByClient,
} from '@src/services/client'
import { getSavedState } from '@src/utils/localStorage'

export const state = {
    listClients: [],
    locationList: [],
    clientFormState: {
        firstName: '',
        lastName: '',
        name: '',
    },
    clientState: {
        locationId: '',
        qField: '',
        qStatus: true,
        qCurrentPage: 1,
        qPageSize: 20,
        Status: false,
    },
}

export const getters = {
    totalList(state) {
        return state.listClients.data ?
            state.listClients.data.totalItemCount :
            0
    },
}

export const mutations = {
    FETCH_LOCALS(state, locals) {
        state.listClients = locals
    },
    SET_STATE(state, payload) {
        if (state.listClients.data) {
            state.listClients.data.items.find(({ publicId }) => {
                return publicId === payload.publicId
            }).status = payload.status
        }
    },
    SET_STATE_FORM(state, payload) {
        state.clientFormState = payload
    },
    UPDATE_PLAN(state, payload) {
        state.clientFormState = payload
    },
    NEXT_PAGE_LIST(state, list) {
        list.forEach((team) => {
            state.listClients.data.items.push(team)
        })
    },
    FETCH_LOCATION_LIST(state, locals) {
        state.locationList = locals
    },
}

export const actions = {
    // retorna a lista de piscinas
    async fetchList({ commit, state }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetList(locationPublicId, parameters)

        if (resp && resp.status === 200) {
            commit('FETCH_LOCALS', resp.data)
        }
    },
    async getClient({ commit }, parameters) {
        const resp = await GetClient(parameters)
        if (resp && resp.status === 200) {
            return resp.data.data
        }
    },
    async saveNewClient({ commit }, parameters) {
        const resp = await PostClient(parameters)
        if (resp && resp.status === 200) {
            commit('FETCH_LOCALS', resp.data)
        }
        return resp
    },
    async editClient({ commit }, parameters) {
        const resp = await PutClient(parameters)
        if (resp && resp.status === 200) {
            commit('FETCH_LOCALS', resp.data)
        }
        return resp
    },
    async delete({ commit, dispatch }, data) {
        const resp = await DeleteClient(data)

        if (resp.status === 200) {
            dispatch('fetchList')
        }
        return resp
    },
    async nextPage({ commit }, currentPage) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetList(locationPublicId, currentPage)
        if (resp.status === 200) {
            commit('NEXT_PAGE_LIST', resp.data.data.items)
        }
    },
    async fetchLocationListByClient({ commit, state }, parameters = {}) {
        const resp = await GetListByClient(
            parameters.locationPublicId,
            parameters
        )

        if (resp && resp.status === 200) {
            commit('FETCH_LOCATION_LIST', resp.data)
        }
    },
    removeLocationList({ commit }) {
        commit('FETCH_LOCATION_LIST', [])
    },
}